// export const BASEURL = "http://192.168.68.115:8080/api/";
export const BASEURL = "https://admin.pmcbd.net/api";



export const APP_VERSION = '0.0.1'
